<!-- Hero Section -->
<section class="hero-section" role="banner">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-lg-6">
        <h1 class="hero-title">Sobre Nosotros</h1>
        <p class="hero-description">
          Somos una empresa social dedicada a transformar el mercado laboral colombiano hacia la inclusión real. 
          Conectamos talento diverso con empresas comprometidas con el cambio.
        </p>
        <div class="hero-stats">
          <div class="stat-item">
            <span class="stat-number">4+</span>
            <span class="stat-label">Años de Experiencia</span>
          </div>
          <div class="stat-item">
            <span class="stat-number">500+</span>
            <span class="stat-label">Personas Colocadas</span>
          </div>
          <div class="stat-item">
            <span class="stat-number">50+</span>
            <span class="stat-label">Empresas Aliadas</span>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="hero-image">
          <img src="assets/images/nosotros-hero.png" alt="Equipo IncluTec" class="img-fluid">
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Main Content -->
<main>
  <!-- Misión y Visión -->
  <section class="mision-vision-section py-5">
    <div class="container">
      <div class="row">
        <div class="col-lg-6 mb-4">
          <div class="card h-100 border-0 shadow-sm">
            <div class="card-body text-center p-4">
              <div class="icon-wrapper mb-3">
                <i class="fas fa-bullseye fa-3x text-primary"></i>
              </div>
              <h3 class="card-title">Nuestra Misión</h3>
              <p class="card-text">
                Facilitar la inclusión laboral de personas con discapacidad en Colombia, 
                conectando talento diverso con empresas comprometidas, y acompañando todo 
                el proceso de transformación organizacional.
              </p>
            </div>
          </div>
        </div>
        <div class="col-lg-6 mb-4">
          <div class="card h-100 border-0 shadow-sm">
            <div class="card-body text-center p-4">
              <div class="icon-wrapper mb-3">
                <i class="fas fa-eye fa-3x text-success"></i>
              </div>
              <h3 class="card-title">Nuestra Visión</h3>
              <p class="card-text">
                Ser la empresa líder en inclusión laboral en Latinoamérica, 
                transformando el mercado laboral hacia la diversidad real y 
                creando un mundo donde todos tengan acceso a oportunidades laborales dignas.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Valores -->
  <section class="valores-section py-5 bg-light">
    <div class="container">
      <div class="section-header text-center mb-5">
        <h2 class="section-title">Nuestros Valores</h2>
        <p class="section-description">
          Los principios que guían cada decisión y acción en IncluTec
        </p>
      </div>
      <div class="row">
        <div class="col-lg-3 col-md-6 mb-4" *ngFor="let valor of valores">
          <div class="valor-card text-center">
            <div class="valor-icon mb-3">
              <i [class]="valor.icono + ' fa-3x ' + valor.color"></i>
            </div>
            <h4 class="valor-titulo">{{ valor.titulo }}</h4>
            <p class="valor-descripcion">{{ valor.descripcion }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>

</main>
